import { PropsWithChildren } from 'react';
import { MinimalIconProps } from '@ardoq/icons';
import { DropdownMenuOptionProps } from './types';

const getIconProps = (
  {
    leftIconName,
    rightIconName,
    leftIcon,
    rightIcon,
  }: PropsWithChildren<DropdownMenuOptionProps>,
  side: 'left' | 'right'
): MinimalIconProps | undefined => {
  if (side === 'left') {
    return leftIconName
      ? {
          name: leftIconName,
        }
      : leftIcon
        ? leftIcon
        : undefined;
  }
  return rightIconName
    ? {
        name: rightIconName,
      }
    : rightIcon
      ? rightIcon
      : undefined;
};

export const dropdownMenuOperations = {
  getIconProps,
};
